import * as tslib_1 from "tslib";
import { BaseControl } from "../../../../../form/src/common/controls/base-control";
import { H3Field, H3Switch } from 'h3-mobile-vue';
import { Component } from "vue-property-decorator";
let InputLogic = class InputLogic extends BaseControl {
};
InputLogic = tslib_1.__decorate([
    Component({
        name: "input-logic",
        components: {
            H3Switch,
            H3Field
        }
    })
], InputLogic);
export default InputLogic;
